export default __webpack_public_path__ + "assets/models/c3714500b0c5f9b68ea6aab8cc90c898.glb";